'use client';
import { useState, useEffect, useRef } from 'react';
import { AxiosInstance } from '../utils';

import Slider from "react-slick";
import Spinner from '../Spinner';

interface AwardJuryMember {
    id: string;
    name: string;
    linkedin?: string;
    imageurl?: string;
}

interface Award {
    id: string;
    title: string;
    shortdesc: string;
    htmldesc?: string;
    awardees?: any[];
}

function AwardsSection({ eventInfo }: any) {
    const [loading, setLoading] = useState(true);
    const [awards, setAwards] = useState<Award[]>([]);
    const [awardees, setAwardees] = useState([] as any);
    const [juryMembers, setJuryMembers] = useState<AwardJuryMember[]>([]);

    var settings = {
        slidesToShow: 3,
        slck: true,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        arrows: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }]
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // Fetch awards data
                const { data: awardsResponse } = await AxiosInstance.get('/api/getawards?eventcode=' + eventInfo.eventcode);
                
                // Fetch jury members data
                const { data: juryResponse } = await AxiosInstance.get('/api/getawardjury?eventcode=' + eventInfo.eventcode);
                
                // Process awards data
                let awardsArray: Award[] = [];
                if (awardsResponse.result === "Success" && awardsResponse.data && Object.keys(awardsResponse.data).length > 0) {
                    awardsArray = Object.keys(awardsResponse.data).map(id => ({
                        id,
                        ...awardsResponse.data[id]
                    }));
                }
                
                // Process jury members data
                let juryArray: AwardJuryMember[] = [];
                if (juryResponse.success && juryResponse.juryMembers && Object.keys(juryResponse.juryMembers).length > 0) {
                    juryArray = Object.keys(juryResponse.juryMembers).map(id => ({
                        id,
                        ...juryResponse.juryMembers[id]
                    }));
                }
                
                // Flatten all awardees
                const allAwardees: any[] = [];
                awardsArray.forEach(award => {
                    if (award.awardees && award.awardees.length > 0) {
                        award.awardees.forEach((awardee: any) => {
                            allAwardees.push({
                                ...awardee,
                                awardTitle: award.title,
                                awardId: award.id
                            });
                        });
                    }
                });

                setAwards(awardsArray);
                setAwardees(allAwardees);
                setJuryMembers(juryArray);
                setLoading(false);
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        }
        fetchData();

        return () => {
        }
    }, []);

    return (
        <section className="event-price-sec sec-padding" id="awards" data-scroll-index="4">
            <div className="container">
                <div className="sec-title">
                    <span className="icon-inner wow flipInY" data-wow-duration="300ms">
                        <span className="fa-stack">
                            <i className="fa rhex fa-stack-2x"></i>
                            <i className="fa fa-trophy fa-stack-1x"></i>
                        </span>
                    </span>
                    <h3 className="wow fadeInRight" data-wow-duration="500ms">Awards <small>/ Recognizing Excellence</small></h3>
                </div>


                <div style={{padding:'20px'}}>
                    <p>Our aim is to recognize executives, leaders, professionals and the best cybersecurity companies & teams in special categories that demonstrate excellence, innovation, influence, impact, and leadership in Cybersecurity. In case of Individual category, both men and women will be recognized equally. Choose the right category from the list given below.  
 </p>
  <br/>
 <div className="text-center">
 <a href="https://forms.gle/LCzAoWaZgJRQ9Y5WA" className="btn-default" target="_blank" rel="noopener noreferrer">Submit your nomination</a> 
 </div>
  <br/>
 </div>
                {/* Award Jury Section */}
                {juryMembers.length > 0 && (
                    <div className="jury-sec mt-5">
                        <div className="row">
                            <div className="col-lg-12">
                                <h4 className="section-subtitle">Award Jury</h4>
                            </div>
                        </div>
                        
                        <div className="row">
                            {juryMembers.map((jury: AwardJuryMember) => (
                                <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={jury.id}>
                                    <div className="award-card">
                                        {jury.imageurl && (
                                            <div className="award-image">
                                                <img src={jury.imageurl} alt={jury.name} style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px' }} />
                                            </div>
                                        )}
                                        <div className="award-content">
                                            <h5 className="award-title">{jury.name}</h5>
                                            {jury.linkedin && (
                                                <a href={jury.linkedin} target="_blank" rel="noopener noreferrer" className="jury-link">
                                                    <i className="fa fa-linkedin"></i>
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
 <div>

                </div>

                {/* Awards Section */}
                <div className="awards-sec">
                    <div className="row">
                        <div className="col-lg-12">
                            <h4 className="section-subtitle">Our Awards</h4>
                        </div>
                    </div>
                    
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                            <Spinner size="medium" />
                        </div>
                    ) : awards.length > 0 ? (
                        <div className="row">
                            {awards.map((award: any) => (
                                <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={award.id}>
                                    <div className="award-card">
                                        {award.imageurl && (
                                            <div className="award-image">
                                                <img src={award.imageurl} alt={award.title} style={{ width: '100%', height: '250px', objectFit: 'fill', borderRadius: '8px' }} />
                                            </div>
                                        )}
                                        <div className="award-content">
                                            <h5 className="award-title">{award.title}</h5>
                                            <p className="award-shortdesc">{award.shortdesc}</p>
                                            {award.htmldesc && (
                                                <div className="award-description" dangerouslySetInnerHTML={{ __html: award.htmldesc }} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center">
                            <p>No awards available at this time.</p>
                        </div>
                    )}
                </div>

                {/* Awardees Section */}
                <div className="awardees-sec mt-5">
                    <div className="row">
                        <div className="col-lg-12">
                            <h4 className="section-subtitle">Our Awardees</h4>
                        </div>
                    </div>
                    
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                            <Spinner size="medium" />
                        </div>
                    ) : awardees.length > 0 ? (
                        <div className="row">
                            {awardees.map((awardee: any) => (
                                <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={awardee.id}>
                                    <div className="awardee-card text-center">
                                        {awardee.photoUrl ? (
                                            <div className="awardee-photo">
                                                <img src={awardee.photoUrl} alt={awardee.name} style={{ width: '120px', height: '120px', objectFit: 'cover', borderRadius: '50%' }} />
                                            </div>
                                        ) : (
                                            <div className="awardee-photo placeholder">
                                                <div style={{ width: '120px', height: '120px', borderRadius: '50%', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto' }}>
                                                    <span style={{ fontSize: '40px', color: '#ccc' }}>👤</span>
                                                </div>
                                            </div>
                                        )}
                                        <div className="awardee-content mt-3">
                                            <h6 className="awardee-name">{awardee.name}</h6>
                                            <p className="awardee-award">{awardee.awardTitle}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center">
                            <p>No awardees available at this time.</p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
};

export { AwardsSection };